import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v3",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Polyline, { points: "14 2 14 8 20 8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m7 10-3 2H2v4h2l3 2v-8Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M11 11c.64.8 1 1.87 1 3s-.36 2.2-1 3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FileVolume";
const FileVolume = memo(themed(Icon));
export {
  FileVolume
};
//# sourceMappingURL=file-volume.js.map
